import { render, staticRenderFns } from "./setQuestion.vue?vue&type=template&id=7d85a994&scoped=true&"
import script from "./setQuestion.vue?vue&type=script&lang=js&"
export * from "./setQuestion.vue?vue&type=script&lang=js&"
import style0 from "./setQuestion.vue?vue&type=style&index=0&id=7d85a994&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d85a994",
  null
  
)

component.options.__file = "setQuestion.vue"
export default component.exports